import React from "react";

const MAP = [
  { k: ["approved", "confirmed", "paid in full", "checked in", "in house", "completed", "accepted", "active", "sent", "ready for arrival"], c: "text-pool border-pool/40 bg-pool/10" },
  { k: ["pending", "request submitted", "request started", "deposit requested", "payment pending", "partially paid", "under review", "started", "queued", "new", "acknowledged", "assigned", "in progress", "waitlisted", "hold", "viewed", "information needed", "draft", "open", "requested"], c: "text-gold border-gold/40 bg-gold/10" },
  { k: ["declined", "cancelled", "no show", "failed", "revoked", "expired", "rejected", "disputed", "written off"], c: "text-red-300 border-red-400/40 bg-red-500/10" },
  { k: ["complimentary", "payment waived", "checked out", "archived", "not configured"], c: "text-purple-200 border-purple-300/40 bg-purple-400/10" },
];

export default function StatusBadge({ status, testid }) {
  const s = (status || "—").toLowerCase();
  const found = MAP.find((m) => m.k.some((x) => s.includes(x)));
  const cls = found ? found.c : "text-muted-foreground border-white/20 bg-white/5";
  return (
    <span data-testid={testid} className={`status-pill border ${cls}`}>{status || "—"}</span>
  );
}
